import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import initialImage from "../../../../Resources/images/images.jpg";
import * as yup from "yup";
import axios from "../../../../HOC/CreateAxios/CreateAxios";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import storage from "../../../../HOC/FIREBASE/FIREBASE";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function AddStaff({ getStaff }) {
  const [progress, setprogress] = useState(0);
  const [progressShow, setprogressShow] = useState(false);
  const Navigate = useNavigate();
  const [slowRedirect, setSlowRedirect] = useState(false);
  // const [Document_right, setDocument_right] = useState("");
  // const [Document_left, setDocument_left] = useState("");

  const StaffFormData = [
    {
      label: "staff Name",
      type: "text",
      apikey: "staff_name",
      placeholder: "Staff name ",
    },
    {
      label: "address",
      type: "text",
      apikey: "address",
      placeholder: "Address ",
    },
    {
      label: "contact no",
      type: "number",
      apikey: "phone_no",
      placeholder: "Contact no ",
    },
    {
      label: "email",
      type: "email",
      apikey: "email",
      placeholder: "Email  ",
    },
    {
      label: "salary",
      type: "number",
      apikey: "salary",
      placeholder: "Salary  ",
    },
    {
      label: "role",
      type: "select",
      apikey: "role",
      options: [
        { value: "select any one role ", id: "" },
        { value: "user", id: "user" },
        { value: "reception", id: "reception" },
      ],
      // placeholder: "role  ",
    },
  ];
  const Image = [
    {
      label: "document left",
      type: "file",
      apikey: "document_left",
      accept: "image/*,.jpg,.png,.jpeg,.mov",
      images:
        "https://media.gettyimages.com/vectors/documents-illustration-icons-vector-id1266753042?s=612x612",
    },
    {
      label: "document right",
      type: "file",
      apikey: "document_right",
      accept: "image/*,.jpg,.png,.jpeg,.mov",
      images:
        "https://media.gettyimages.com/vectors/documents-illustration-icons-vector-id1266753042?s=612x612",
    },
    {
      label: "staff image",
      type: "file",
      apikey: "employee_img",
      accept: "image/*,.jpg,.png,.jpeg,.mov",
      images: initialImage,
    },
  ];
  const Submit = (val, resetForm) => {
    let formData = new FormData();
    formData.append("staff_name", val.staff_name);
    formData.append("address", val.address);
    formData.append("phone_no", val.phone_no);
    formData.append("email", val.email);
    formData.append("salary", val.salary);
    formData.append("role", val.role);
    formData.append("employee_img", val.employee_img);
    formData.append("document_left", val.document_left);
    formData.append("document_right", val.document_right);
    axios
      .post(`/staff`, formData)
      .then((res) => {
        console.log(res);
        if (res.status === 201) {
          setprogressShow(false);
          getStaff();
          toast.success("Staff has been added sucessfully");

          resetForm();

          // return true;
          // setSlowRedirect(true);
        }
      })
      .catch((err) => {
        console.log(err);
        setprogressShow(false);
      });
  };
  const StaffSchema = yup.object().shape({
    staff_name: yup.string().required("Required!!"),
    address: yup.string().required("Required!!"),
    phone_no: yup.string().required("Required!!"),
    salary: yup.string().required("Required!!"),
    role: yup.string().required("Required!!"),
    // document_right: yup.string().required("Required!!"),
    email: yup.string().email("Invalid email").required("Required!!"),
  });
  return (
    <div>
      <ToastContainer autoClose={1000} />
      <div className="my-5 px-5">
        <Formik
          initialValues={{
            staff_name: "",
            address: "",
            phone_no: "",
            email: "",
            salary: "",
            employee_img: "",
            document_right: "",
            document_left: "",
            role: "",
          }}
          validationSchema={StaffSchema}
          onSubmit={(values, { resetForm }) => {
            // console.log(values);
            Submit(values, resetForm);
          }}
        >
          {({ touched, errors, handleSubmit, values, setFieldValue }) => {
            return (
              <Form onSubmit={handleSubmit} className=" w-full ">
                {console.log(values, "dvd")}
                <div className="laptop:grid laptop:grid-cols-2 gap-x-8">
                  {StaffFormData.map((val, i) => {
                    if (val.type === "select") {
                      return (
                        <div>
                          <div className="my-2 capitalize   font-semibold text-lg text-gray-700">
                            <label
                              className="cursor-pointer"
                              htmlFor={val.apikey}
                            >
                              {val.label}
                            </label>
                          </div>
                          <Field
                            as={val.type}
                            name={val.apikey}
                            className="border bg-gray-50 outline-none w-full p-3 rounded-md"
                          >
                            {val.options.map((opti, id) => {
                              return (
                                <option
                                  key={opti.id ? opti.id : null}
                                  value={opti.id}
                                >
                                  {opti.value}
                                </option>
                              );
                            })}
                          </Field>
                          <div className="text-red-400 text-xs font-medium">
                            {errors[val.apikey] && touched[val.apikey]
                              ? errors[val.apikey]
                              : ""}
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div key={i}>
                          <div className="my-1 capitalize   font-semibold text-lg text-gray-700">
                            <label
                              className="cursor-pointer"
                              htmlFor={val.apikey}
                            >
                              {val.label}
                            </label>
                          </div>
                          <div className="my-1.5">
                            <Field
                              type={val.type}
                              placeholder={val.placeholder}
                              id={val.apikey}
                              name={val.apikey}
                              className="border bg-gray-50 outline-none w-full p-3 rounded-md"
                            />
                          </div>
                          <div className="text-red-400 text-xs font-medium">
                            {errors[val.apikey] && touched[val.apikey]
                              ? errors[val.apikey]
                              : ""}
                          </div>
                        </div>
                      );
                    }
                  })}
                </div>
                {/* for images or document */}
                <div
                  className={`  laptop:grid grid-cols-2 gap-5 my-7   w-full`}
                >
                  {Image.map((val, i) => {
                    let AllImage = val.apikey;
                    return (
                      <div
                        key={i}
                        className={` ${
                          val.apikey === "employee_img"
                            ? "  col-span-2 row-start-1 "
                            : "row-start-2 "
                        }`}
                      >
                        <div className="my-2 capitalize   font-semibold text-lg text-gray-700">
                          <label
                            className="cursor-pointer"
                            htmlFor={val.apikey}
                          >
                            {val.label}
                          </label>
                        </div>
                        <div className="border bg-gray-100 p-4 full">
                          <label
                            htmlFor={val.apikey}
                            className={`cursor-pointer`}
                          >
                            {console.log(values.AllImage)}
                            <img
                              src={
                                values[val.apikey]
                                  ? URL.createObjectURL(values[val.apikey])
                                  : val.images
                              }
                              alt="Loading ..."
                              height="100px"
                              width="400px"
                              className="m-auto h-60 laptop:h-80 "
                            />
                          </label>
                        </div>
                        <div className="hidden">
                          <input
                            name={val.apikey}
                            id={val.apikey}
                            type={val.type}
                            accept={val.accept}
                            onChange={(e) => {
                              let file = e.target.files[0];
                              console.log(file, AllImage);
                              setFieldValue(AllImage, e.target.files[0]);
                            }}
                          />
                        </div>
                        <div className="text-red-400 text-xs font-medium">
                          {errors[val.apikey] && touched[val.apikey]
                            ? errors[val.apikey]
                            : ""}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div>
                  <button
                    onClick={handleSubmit}
                    // type="submit"
                    className="bg-green-400 text-white 
                  px-5 py-2 font-semibold Poppins 
                  text-lg rounded-md capitalize"
                  >
                    submit
                  </button>
                </div>
              </Form>
            );
          }}
        </Formik>
        <ToastContainer />
      </div>
    </div>
  );
}

export default AddStaff;
